import { api } from './base';

// Enums
export enum Accessible {
  ALL = 'all', // 公开
  EMPLOYEE_ONLY = 'employee_only', // 内部所有人
  RECIPIENTS_ONLY = 'recipients_only' // 仅限内部收件人
}

export enum UploadStatus {
  SUCCESS = 0,
  PENDING = 1,
  FAILED = 10,
  DELETED = -1
}

// Request interfaces
export interface AttachmentListRequest {
  page?: number; // default: 1
  page_size?: number; // default: 20
  query?: string;
}

export interface AttachmentRequest {
  accessible: Accessible;
  expire_in_seconds: number;
  filename: string;
  filesize_bytes: number;
  content_type?: string;
}

export interface AttachmentComplete {
  attachment_uid: string;
  etag: string; // 带引号的
}

// Response interfaces
export interface MailAttachment {
  id: number;
  uid: string;
  owner_id: number;
  bucket: string;
  filename: string;
  filepath: string;
  expire_at: string; // ISO datetime string
  accessible_str: string;
  accessible_users: number[] | null;
  etag: string | null;
  state: number; // UploadStatus value
  create_time: string; // ISO datetime string
  modified_time: string; // ISO datetime string
  filesize_bytes?: number;
}

export interface AttachmentListResponse {
  items: MailAttachment[];
  total: number;
}

export interface AttachmentSignedUrlResponse {
  attachment: MailAttachment;
  pre_signed_url: string;
  headers: Record<string, string>;
}

export interface AttachmentShareLinkResponse {
  link: string;
  html: string;
}

export const attachmentApis = {
  listMyAttachment: (req: AttachmentListRequest): Promise<AttachmentListResponse> => {
    return api.get('/mail/attachments', { params: req });
  },
  requestPutSignedUrl: (req: AttachmentRequest): Promise<AttachmentSignedUrlResponse> => {
    return api.post('/mail/attachments/signed/request', req);
  },
  completePutSignedUrl: (req: AttachmentComplete): Promise<void> => {
    return api.post('/mail/attachments/signed/complete', req);
  },
  sharedAttachment: (attachment_uid: string): Promise<AttachmentShareLinkResponse> => {
    return api.get(`/mail/attachments/${attachment_uid}/share-link`);
  },
  getAttachmentInfo: (attachment_uid: string): Promise<MailAttachment> => {
    return api.post(`/mail/attachments/${attachment_uid}/info`);
  },
  getAttachmentDownloadLink: (attachment_uid: string): Promise<{ link: string }> => {
    return api.post(`/mail/attachments/${attachment_uid}/download-link`);
  }
};
